import React from "react";
import { colors } from "../../colors/color";
import { Icon, iconName } from "../../icons/Icons";
import { TooltipTheOneWrapper } from "../../TooltipTheOne";
import { Flex } from "../FlexHelpers";

export function IconWithText(props: React.PropsWithChildren<{
    tooltipContent?: React.ReactNode, 
    variant: 'default' | 'passive' | 'active' | 'disabled' | 'success' | 'warning' | 'error',
    icon:iconName
}>): JSX.Element {

    const component =   <Flex flexDirection="row" alignItems="center" gap={4}>
                            <Icon name={props.icon} color={colors.icon[props.variant]} />
                            <span>{props.children}</span>
                        </Flex>;
    
    if(props.tooltipContent)
        return (
            <TooltipTheOneWrapper tooltipContent={props.tooltipContent} horizontalAlignment='left'>
                {component}
            </TooltipTheOneWrapper>
        );
    
    return component;
}